// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"416":"be9a8862","498":"f21a7c2a","703":"96a3f55c"}[chunkId] + ".chunk.js";
};